import { commonButtonText } from "app/pages/activation/constants/texts";

export const CONFIRM_DEFAULT_ACTIVATION_MODAL_TITLE = "activation.default.homepage.modal.title";
export const CONFIRM_DEFAULT_ACTIVATION_MODAL_CONTENT = "activation.default.homepage.modal.content";
export const CONFIRM_DEFAULT_ACTIVATION_MODAL_UPDATE_BUTTON = "activation.default.homepage.modal.update.button";
export const CONFIRM_DEFAULT_ACTIVATION_MODAL_CLOSE_BUTTON = commonButtonText.close;

export const CONFIRM_DEFAULT_ACTIVATION_TOAST_MESSAGE = "activation.toast.success.set.default.homepage";
export const CONFIRM_DEFAULT_ACTIVATION_TOAST_MESSAGE_REMOVE = "activation.toast.success.remove.default.homepage";
